import { ComponentType } from '../../types'
import { fetchComponentTypes } from '../../services/component-types.service'
import createBaseStore from '../createStoreHelper'

export const ComponentTypeModule: any = createBaseStore<ComponentType>({
  resourceName: 'component-type',
  plural: 'component-types',
  apiCalls: {
    fetchAllApiCall: fetchComponentTypes
  }
})
